"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var jsx_runtime_1 = require("react/jsx-runtime");
var faFilter_1 = require("@fortawesome/pro-regular-svg-icons/faFilter");
var end2end_1 = require("@hudled/end2end");
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var material_1 = require("@mui/material");
var Autocomplete_1 = __importStar(require("@mui/material/Autocomplete"));
var react_2 = __importDefault(require("react"));
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var AutocompletePopover_1 = __importDefault(require("atomicComponents/atoms/MultiSelect/AutocompletePopover"));
var MultiselectTextfield_1 = __importDefault(require("atomicComponents/atoms/MultiSelect/MultiselectTextfield"));
var OptionChip_1 = __importDefault(require("atomicComponents/atoms/MultiSelect/OptionChip"));
var MultiSelect_1 = require("atomicComponents/organisms/MultiSelect");
var Filter = function (_a) {
    var options = _a.options, results = _a.results, setResults = _a.setResults, disableGroupOptions = _a.disableGroupOptions;
    var _b = __read(react_2.default.useState(null), 2), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleClick = function (event) { return setAnchorEl(anchorEl ? null : event.currentTarget); };
    var handleClose = function () { return setAnchorEl(null); };
    var filter = (0, Autocomplete_1.createFilterOptions)();
    var filterOptions = function (opts, params) {
        var filtered = filter(opts, params);
        return filtered.filter(function (opt) { return !(results === null || results === void 0 ? void 0 : results.find(function (v) { return v.value === opt.value; })); });
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ color: "neutral", size: "small", icon: faFilter_1.faFilter, onClick: handleClick }, { children: results.length > 0 ? (0, end2end_1.handlePlural)('selected filter')(results.length) : 'Filter' })), (0, jsx_runtime_1.jsx)(AutocompletePopover_1.default, __assign({ open: !!anchorEl, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'right' } }, { children: (0, jsx_runtime_1.jsx)(Autocomplete_1.default, { open: true, multiple: true, disableCloseOnSelect: true, forcePopupIcon: false, options: options || [], filterOptions: filterOptions, getOptionLabel: function (option) { return "".concat(option.label); }, PopperComponent: MultiSelect_1.PopperComponent, value: results, renderTags: function (tag, getTagProps) { return tag.map(function (option, index) { return ((0, react_1.createElement)(OptionChip_1.default, __assign({ variant: "outlined", label: option.label }, getTagProps({ index: index }), { deleteIcon: (0, jsx_runtime_1.jsx)(Close_1.default, {}), key: option.value }))); }); }, groupBy: disableGroupOptions ? undefined : (function (option) { return option.category || ''; }), renderInput: function (inputProps) { return (0, jsx_runtime_1.jsx)(MultiselectTextfield_1.default, __assign({}, inputProps, { color: "secondary" })); }, onChange: function (event, newValue) { return setResults(newValue || []); } }) }))] })));
};
exports.default = Filter;
